import React, { Component } from 'react';
import { connect } from 'react-redux';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import ActionType from '../../../redux/reducer/globalActionType';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import RemarkMenu from '../../../components/MasterData/RemarkMenu';
import IconActionEditBlue from '../../../assets/icons/IconActionEditBlue';
import IconActionDeleteBlue from '../../../assets/icons/IconActionDeleteBlue';
import IconAddTransparent from '../../../assets/icons/IconAddTransparent';
import IconInformationBlue from '../../../assets/icons/IconInformationBlue';
import ButtonBorderNexcareDefault from '../../../components/Button/ButtonBorderNexcareDefault';
import ButtonNexcareDefault from '../../../components/Button/ButtonNexcareDefault';
import TableNexcare from '../../../components/Table/TableNexcare';
import API_REMARK from '../../../api/apiRemark';
import Alert from '../../../components/Alert/Alert';
import Mandatory from '../../../components/Common/Mandatory';
import MandatoryAlert from '../../../components/Common/MandatoryAlert';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    MASTER_DATA_REMARK_DELETE,
    MASTER_DATA_REMARK_INSERT,
    MASTER_DATA_REMARK_UPDATE,
    MASTER_DATA_REMARK_VIEW
} from '../../../constants/menuPermissionConstant';

class Priority extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            columns: [
                {
                    title: "Remark",
                    dataIndex: "remark",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Deskripsi Remark",
                    dataIndex: "description",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Warna Label",
                    dataIndex: "additional_value",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => (
                        <div style={{ backgroundColor: data }} className="h-5 w-20 rounded-md" />
                    ),
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    width: "w-1/12",
                    render: (data) => (
                        <div className="flex items-center space-x-3">
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btnedit" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showEditModal: true, priorityDataSelectedEdit: data, priorityTitle: data.remark, priorityDescription: data.description }, () => this.handleChangeDefaultColor(data.additional_value))}>
                                    <IconActionEditBlue />
                                </div>
                            </CheckPermissionComponent>
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_DELETE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btndelete" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showConfirmDeleteAlert: true, priorityDataSelectedDelete: data })}>
                                    <IconActionDeleteBlue />
                                </div>
                            </CheckPermissionComponent>
                        </div>
                    ),
                },
            ],
            listPriority: [],
            priorityTitle: '',
            priorityDescription: '',
            listColor: [
                {
                    selected: false,
                    color: '#92989D'
                },
                {
                    selected: false,
                    color: '#57C22D'
                },
                {
                    selected: false,
                    color: '#F8AC30'
                },
                {
                    selected: false,
                    color: '#FF6F00'
                },
                {
                    selected: false,
                    color: '#CB1801'
                },
                {
                    selected: false,
                    color: '#BC007C'
                },
                {
                    selected: false,
                    color: '#5A005A'
                },
                {
                    selected: false,
                    color: '#0068BE'
                },
                {
                    selected: true,
                    color: '#DADCDE'
                },
                {
                    selected: false,
                    color: '#ABE096'
                },
                {
                    selected: false,
                    color: '#FBD597'
                },
                {
                    selected: false,
                    color: '#FFB77F'
                },
                {
                    selected: false,
                    color: '#E58B80'
                },
                {
                    selected: false,
                    color: '#D276B2'
                },
                {
                    selected: false,
                    color: '#AC7FAC'
                },
                {
                    selected: false,
                    color: '#7FB3DE'
                },
                {
                    selected: false,
                    color: '#4C9488'
                },
                {
                    selected: false,
                    color: '#57891B'
                },
                {
                    selected: false,
                    color: '#CAA628'
                },
                {
                    selected: false,
                    color: '#EF5165'
                },
                {
                    selected: false,
                    color: '#FF29A2'
                },
                {
                    selected: false,
                    color: '#9017E6'
                },
                {
                    selected: false,
                    color: '#4500B4'
                },
                {
                    selected: false,
                    color: '#2355F3'
                },
                {
                    selected: false,
                    color: '#62E9B8'
                },
                {
                    selected: false,
                    color: '#C1DF1F'
                },
                {
                    selected: false,
                    color: '#FFD500'
                },
                {
                    selected: false,
                    color: '#F8C4B4'
                },
                {
                    selected: false,
                    color: '#FFA5CF'
                },
                {
                    selected: false,
                    color: '#DC93F6'
                },
                {
                    selected: false,
                    color: '#9262E0'
                },
                {
                    selected: false,
                    color: '#2DCBFC'
                },
                {
                    selected: false,
                    color: '#004346'
                },
                {
                    selected: false,
                    color: '#585123'
                },
                {
                    selected: false,
                    color: '#7C6A0A'
                },
                {
                    selected: false,
                    color: '#CA5310'
                },
                {
                    selected: false,
                    color: '#8F250C'
                },
                {
                    selected: false,
                    color: '#80489C'
                },
                {
                    selected: false,
                    color: '#5E66AB'
                },
                {
                    selected: false,
                    color: '#184E77'
                },
                {
                    selected: false,
                    color: '#7A9E7E'
                },
                {
                    selected: false,
                    color: '#D2CB9D'
                },
                {
                    selected: false,
                    color: '#E6D474'
                },
                {
                    selected: false,
                    color: '#EB9A6D'
                },
                {
                    selected: false,
                    color: '#B77667'
                },
                {
                    selected: false,
                    color: '#9E5092'
                },
                {
                    selected: false,
                    color: '#B8C0FF'
                },
                {
                    selected: false,
                    color: '#6896B7'
                },
            ],
            priorityDataSelectedEdit: {},
            priorityDataSelectedDelete: {},
            showWarningPriorityTitle: false,
            showWarningPriorityDescription: false,
            showPopupInfo: false,
            showAddModal: false,
            showEditModal: false,
            showConfirmAddAlert: false,
            showSuccessAddAlert: false,
            showConfirmEditAlert: false,
            showSuccessEditAlert: false,
            showConfirmDeleteAlert: false,
            showSuccessDeleteAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                this.getInitiatePriority();
                this.getListPriority(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                this.getInitiatePriority();
                this.getListPriority(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleChangeDefaultColor = selectedColor => {
        if (!selectedColor) selectedColor = '#DADCDE';
        if (!this.state.listColor.find(data => data.color === selectedColor)) selectedColor = '#DADCDE';

        const updatedListColor = this.state.listColor.map((color) => ({
            ...color,
            selected: color.color === selectedColor
        }));

        this.setState({ listColor: updatedListColor });
    }

    handleChangeColor = index => {
        const updatedListColor = [...this.state.listColor];
        updatedListColor.forEach((color, i) => {
            if (i === index) {
                color.selected = true;
            } else {
                color.selected = false;
            }
        });

        this.setState({ listColor: updatedListColor });
    }

    getInitiatePriority = () => {
        API_REMARK.getInitiatePriority(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: { ...this.state.pagination, total: getContent(res).count_data }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListPriority = (current, pageSize) => {
        API_REMARK.getListPriority(current, pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        listPriority: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleCancelButton = () => {
        this.setState({
            showAddModal: false,
            showEditModal: false,
            showWarningPriorityTitle: false,
            showWarningPriorityDescription: false,
            priorityTitle: '',
            priorityDescription: ''
        });
    }

    handleConfirmAddPriority = () => {
        if (!this.state.priorityTitle || !this.state.priorityDescription) {
            if (!this.state.priorityTitle) this.setState({ showWarningPriorityTitle: true });
            if (!this.state.priorityDescription) this.setState({ showWarningPriorityDescription: true });
            return;
        }
        this.setState({ showConfirmAddAlert: true });
    }

    handleAddPriority = () => {
        const data = {
            remark: this.state.priorityTitle,
            description: this.state.priorityDescription,
            additional_value: this.state.listColor.find(data => data.selected === true).color,
            category: 'Priority'
        }

        API_REMARK.postDataRemark(data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showAddModal: false,
                        showConfirmAddAlert: false,
                        showSuccessAddAlert: true,
                        priorityTitle: '',
                        priorityDescription: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmAddAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessAddPriority = () => {
        this.setState({
            showSuccessAddAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiatePriority();
            this.getListPriority(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleConfirmEditPriority = () => {
        if (!this.state.priorityTitle || !this.state.priorityDescription) {
            if (!this.state.priorityTitle) this.setState({ showWarningPriorityTitle: true });
            if (!this.state.priorityDescription) this.setState({ showWarningPriorityDescription: true });
            return;
        }
        this.setState({ showConfirmEditAlert: true });
    }

    handleEditPriority = () => {
        const priorityId = this.state.priorityDataSelectedEdit.id;
        const data = {
            remark: this.state.priorityTitle,
            description: this.state.priorityDescription,
            additional_value: this.state.listColor.find(data => data.selected === true).color,
            category: 'Priority',
            category_id: this.state.priorityDataSelectedEdit.category_id,
            updated_at: this.state.priorityDataSelectedEdit.updated_at
        }

        API_REMARK.putDataRemark(priorityId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showEditModal: false,
                        showConfirmEditAlert: false,
                        showSuccessEditAlert: true,
                        priorityTitle: '',
                        priorityDescription: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmEditAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessEditPriority = () => {
        this.setState({
            showSuccessEditAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiatePriority();
            this.getListPriority(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleDeletePriority = () => {
        this.setState({ showConfirmDeleteAlert: false });

        const priorityId = this.state.priorityDataSelectedDelete.id;
        const data = {
            remark: this.state.priorityDataSelectedDelete.remark,
            category: 'Priority',
            updated_at: this.state.priorityDataSelectedDelete.updated_at
        }
        API_REMARK.deleteDataRemark(priorityId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({ showSuccessDeleteAlert: true });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessDeletePriority = () => {
        this.setState({
            showSuccessDeleteAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiatePriority();
            this.getListPriority(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getInitiatePriority();
        this.getListPriority(this.state.pagination.current, this.state.pagination.pageSize);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    {/* Breadcrumbs */}
                    <BreadCrumbs
                        parentMenu="Master Data"
                        serviceMenu="Remark"
                        title="Prioritas"
                    />

                    {/* White Container */}
                    <div className="h-content">
                        {/* Content */}
                        <div className="calculate-layout-blank bg-white border border-gray-300 rounded-lg px-6 py-10 space-y-10 overflow-auto">
                            {/* Menu */}
                            <RemarkMenu />

                            <div className="space-y-4">
                                <div className="flex justify-between items-center flex-row-reverse h-12">
                                    {/*  Priority Information */}
                                    <div className="flex justify-center items-center relative">
                                        <div id="btninfo" className="cursor-pointer" onMouseEnter={() => this.setState({ showPopupInfo: true })} onMouseLeave={() => this.setState({ showPopupInfo: false })}>
                                            <IconInformationBlue />
                                        </div>
                                        <div className={this.state.showPopupInfo ? "absolute w-96 top-0 right-10 z-10 rounded-lg shadow-box-button p-5 text-sm bg-nexcarewhite2" : "hidden"}>
                                            <div className="italic">
                                                <p className="font-bold">Note :</p>
                                                <p>Prioritas digunakan untuk menentukan Target Resolusi dari masing masing prioritas.</p>
                                                <p>Warna label akan ditampilkan pada list tiket untuk pewarnaan berdasarkan prioritas.</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Add Priority Button */}
                                    <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_INSERT]} userPermission={this.props.userDetail.permissions}>
                                        <button id="btnaddpriority" onClick={() => this.setState({ showAddModal: true }, () => this.handleChangeDefaultColor('#DADCDE'))} className="flex items-center text-white py-2 px-6 rounded-md bg-nexcaredefault cursor-pointer">
                                            <IconAddTransparent />
                                            <span className="ml-2">Priority</span>
                                        </button>
                                    </CheckPermissionComponent>
                                </div>

                                {/* Table Priority */}
                                <div>
                                    <TableNexcare
                                        column={this.state.columns}
                                        dataTable={this.state.listPriority}
                                        pagination={this.state.pagination}
                                        onPage={this.handleSelectedPage}
                                        onPageSize={this.handleSelectedPageSize}
                                        halfBodyHeight
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Add Priority Modal */}
                    <div className={this.state.showAddModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Tambah Prioritas</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Tampilan Label Prioritas</p>
                                    <div className="h-32 bg-nexcarewhite3 flex justify-center items-center rounded-md">
                                        <div className="flex items-center space-x-1 h-full">
                                            <p>{this.state.priorityDescription ? this.state.priorityDescription : 'Deskripsi Remark'}</p>
                                            <span style={{ backgroundColor: this.state.listColor.find(data => data.selected === true).color }} className="h-4 w-4 rounded-full"></span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Remark <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tslprioritytitleadd"
                                        className="form-control"
                                        placeholder="Tulis Remark"
                                        name="priorityTitle"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningPriorityTitle: false });
                                        }}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                        value={this.state.priorityTitle}
                                    />
                                    {this.state.showWarningPriorityTitle && <MandatoryAlert text="Remark tidak boleh kosong!" />}
                                </div>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Deskripsi Remark <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tslprioritydescriptionadd"
                                        className="form-control"
                                        placeholder="Tulis Deskripsi Remark"
                                        name="priorityDescription"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningPriorityDescription: false });
                                        }}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                        value={this.state.priorityDescription}
                                    />
                                    {this.state.showWarningPriorityDescription && <MandatoryAlert text="Deskripsi Remark tidak boleh kosong!" />}
                                </div>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Warna Label</p>
                                    <div className="grid grid-cols-8 gap-1">
                                        {
                                            this.state.listColor.map((data, idx) =>
                                                <div key={idx} className={`w-10 h-10 p-px rounded-full cursor-pointer ${data.selected && 'border-2 border-nexcaredefault'}`}>
                                                    <div style={{ backgroundColor: data.color }} className="h-full w-full rounded-full" onClick={() => this.handleChangeColor(idx)} />
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btnaddpriority" onClick={this.handleConfirmAddPriority}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Edit Priority Modal */}
                    <div className={this.state.showEditModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Ubah Prioritas</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Tampilan Label Prioritas</p>
                                    <div className="h-32 bg-nexcarewhite3 flex justify-center items-center rounded-md">
                                        <div className="flex items-center space-x-1 h-full">
                                            <p>{this.state.priorityDescription ? this.state.priorityDescription : 'Deskripsi Remark'}</p>
                                            <span style={{ backgroundColor: this.state.listColor.find(data => data.selected === true).color }} className="h-4 w-4 rounded-full"></span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <input
                                        type="text"
                                        id="tslprioritytitleedit"
                                        className="form-control"
                                        placeholder="Tulis Remark"
                                        name="priorityTitle"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningPriorityTitle: false });
                                        }}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                        value={this.state.priorityTitle}
                                    />
                                    {this.state.showWarningPriorityTitle && <MandatoryAlert text="Remark tidak boleh kosong!" />}
                                </div>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Deskripsi Remark <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tslprioritydescriptionedit"
                                        className="form-control"
                                        placeholder="Tulis Deskripsi Remark"
                                        name="priorityDescription"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningPriorityDescription: false });
                                        }}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                        value={this.state.priorityDescription}
                                    />
                                    {this.state.showWarningPriorityDescription && <MandatoryAlert text="Deskripsi Remark tidak boleh kosong!" />}
                                </div>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Warna Label</p>
                                    <div className="grid grid-cols-8 gap-1">
                                        {
                                            this.state.listColor.map((data, idx) =>
                                                <div key={idx} className={`w-10 h-10 p-px rounded-full cursor-pointer ${data.selected && 'border-2 border-nexcaredefault'}`}>
                                                    <div style={{ backgroundColor: data.color }} className="h-full w-full rounded-full" onClick={() => this.handleChangeColor(idx)} />
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btneditpriority" onClick={this.handleConfirmEditPriority}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Alert */}
                    <Alert show={this.state.showConfirmAddAlert} button title="Simpan Prioritas" desc="Apakah Anda yakin ingin menyimpan data?" close={() => this.setState({ showConfirmAddAlert: false })} submit={this.handleAddPriority} />
                    <Alert show={this.state.showSuccessAddAlert} icon="success" title="Berhasil" desc="Data berhasil disimpan" close={this.handleSuccessAddPriority} ok />
                    <Alert show={this.state.showConfirmEditAlert} button title="Simpan Prioritas" desc="Apakah Anda yakin ingin mengubah data?" close={() => this.setState({ showConfirmEditAlert: false })} submit={this.handleEditPriority} />
                    <Alert show={this.state.showSuccessEditAlert} icon="success" title="Berhasil" desc="Data berhasil diubah" close={this.handleSuccessEditPriority} ok />
                    <Alert show={this.state.showConfirmDeleteAlert} button title="Hapus Prioritas" desc="Apakah Anda yakin ingin menghapus data?" close={() => this.setState({ showConfirmDeleteAlert: false, priorityDataSelectedDelete: {} })} submit={this.handleDeletePriority} />
                    <Alert show={this.state.showSuccessDeleteAlert} icon="success" title="Berhasil" desc="Data berhasil dihapus" close={this.handleSuccessDeletePriority} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Priority);